/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-daisyui';
import { useDebounce } from 'use-debounce';
import { toast } from 'react-toastify';

import { CustomTable, PrimaryButton, SearchBar } from 'components';
import { Confirm } from 'components/Icons';
import { apiErrorHandler } from 'api/handler';
import { fetchUnlinkedChannelsList } from 'services/messenger.service';

function LinkChannelModal(props: any) {
  const { show, toggleModal, handleConfirm, modalData } = props;

  const tableHeaders = [
    {
      key: 'sequenceId',
      value: 'Channel ID',
    },
    {
      key: 'channelName',
      value: 'Channel Name',
    },
    {
      key: 'description',
      value: 'Description',
    },
    {
      key: 'isChecked',
      value: '',
      type: 'isChecked',
    },
  ];

  const [listData, setListData] = useState({
    totalDocs: 0,
    totalPages: 0,
    limit: 10,
    page: 1,
    headers: tableHeaders,
    docs: [],
    sort: null,
    order: -1,
  });

  const [searchByInput, setSearchByInput] = React.useState();
  const [debouncedSearchBy] = useDebounce(searchByInput, 500);

  const [selectedRows, setSelectedRows] = useState<any>([]);

  useEffect(() => {
    if (modalData?.recordId) {
      fetchListData();
    }
  }, [modalData?.recordId, debouncedSearchBy]);

  async function fetchListData(page = 1) {
    try {
      const query = { ...listData, searchBy: searchByInput, page };
      delete query.docs;

      const { data } = await fetchUnlinkedChannelsList(modalData.recordId, query);
      if (data?.node?.docs) {
        if (data.node.page === 1) {
          setListData({
            ...listData,
            ...data.node,
            docs: data.node.docs,
          });
        } else {
          setListData({
            ...listData,
            ...data.node,
            docs: [...listData.docs, ...data.node.docs],
          });
        }
      }
    } catch (e) {
      const { message: exception } = apiErrorHandler(e);
      toast.error(exception);
    }
  }

  const handleTableSelectChange = (event, row) => {
    const { checked } = event.target;
    if (checked) {
      // If checked is true and row is not in selectedRows, add it
      if (!selectedRows.some((selectedRow) => selectedRow._id === row._id)) {
        setSelectedRows([...selectedRows, row]);
      }
    } else {
      // If checked is false and row is in selectedRows, remove it
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow._id !== row._id));
    }
  };

  const handleOnSearch = async (event) => {
    const { value } = event.target;
    setSearchByInput(value);
  };

  return (
    <Modal
      open={show}
      className="top-0 left-0 right-0 p-0 border border-gainsboroBlue rounded-lg z-50 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(auto-1rem)] max-w-3xl max-h-full"
    >
      <Modal.Header className="font-bold pb-2 border-b p-4">
        <div className="flex justify-between items-center">
          <div className="grid grid-cols-1 sm:grid-cols-2 w-fit flex-wrap items-center">
            <div className="text-base font-bold font-ptScanCap whitespace-nowrap">
              Link Channels
            </div>
          </div>
          <div className="text-sm font-normal bg-red">
            <Button
              size="xs"
              shape="circle"
              className="btn btn-xs btn-circle border-2 bg-white border-rasinBlack font-bold"
              onClick={toggleModal}
            >
              x
            </Button>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="pb-6 px-6 pt-3 justify-center items-center -mt-6">
          <div className="w-1/3 mb-4">
            <SearchBar
              placeholder="Search by Channel Name"
              searchByInput={searchByInput}
              onSearch={handleOnSearch}
            />
          </div>
          <CustomTable
            tableData={listData}
            showPageLimit={false}
            fixedHeight
            tableRowSelect={handleTableSelectChange}
          />
        </div>

        <div className="w-full pt-5 pb-5 mt-3 bg-culturedGray flex flex-wrap justify-center items-center gap-3">
          <PrimaryButton
            text="Confirm"
            btnColor="bg-spaceCadetBlue80"
            btnHoverColor="hover:bg-spaceCadetBlue"
            color="white"
            icon={<Confirm />}
            textSize="xs font-bold font-ptScanCap"
            radius="2xl"
            handleOnClick={() => handleConfirm(selectedRows)}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

LinkChannelModal.propTypes = {
  show: PropTypes.bool,
  toggleModal: PropTypes.func,
  handleConfirm: PropTypes.func,
  modalData: PropTypes.any,
};

export default LinkChannelModal;
